/* GleamCanvas accounts + cloud saving.
   Nothing on the site needs an account. This script only adds "save to my account":
   signed-in customers can keep their journal and designs in the GleamCanvas cloud.

   Live (Shopify): theme.liquid sets window.GC_ACCOUNT = { enabled, loggedIn, firstName, loginUrl, accountUrl, logoutUrl, proxy }.
     Saving goes through the store's app proxy (proxy + "/data/<key>"), which tells our cloud helper
     which customer is signed in (see cloud/worker.js).
   Preview site (no GC_ACCOUNT): a pretend account saved in this browser, so the flow can be tried out.
   Copied to shopify-theme/assets by tools/build-theme-js.js, so edit it here only.

   API (window.GCCloud):
     ready                Promise<status>   status = { mode: "live"|"demo"|"off", loggedIn, firstName, cloud: "ok"|"unavailable"|"" }
     status()             current status
     load(key)            Promise<value|null>    keys: "journal", "designs"
     save(key, value)     Promise<true>
     invite(reason)       show the "create a free account" window
     onChange(fn)         called when the status changes (e.g. demo sign-in) */
(function () {
  "use strict";
  var cfg = window.GC_ACCOUNT, listeners = [];
  var DEMO_KEY = "gc_demo_account", DEMO_DATA = "gc_demo_cloud_";
  var st = { mode: cfg ? (cfg.enabled ? "live" : "off") : "demo", loggedIn: false, firstName: "", cloud: "" };

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function emit() { listeners.forEach(function (fn) { try { fn(st); } catch (e) {} }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  var ready;
  if (st.mode === "live") {
    st.loggedIn = !!cfg.loggedIn; st.firstName = cfg.firstName || "";
    // Ask the cloud helper if it's switched on (it replies only through the store's app proxy)
    ready = !st.loggedIn ? Promise.resolve(st) : fetch(cfg.proxy + "/ping", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { st.cloud = j && j.ok && j.loggedIn ? "ok" : "unavailable"; return st; })
      .catch(function () { st.cloud = "unavailable"; return st; });
  } else if (st.mode === "demo") {
    var who = get(DEMO_KEY);
    st.loggedIn = !!who; st.firstName = who || ""; st.cloud = st.loggedIn ? "ok" : "";
    ready = Promise.resolve(st);
  } else ready = Promise.resolve(st);
  ready.then(emit);

  function load(key) {
    if (!st.loggedIn || st.cloud !== "ok") return Promise.reject(new Error("not-signed-in"));
    if (st.mode === "demo") { try { return Promise.resolve(JSON.parse(get(DEMO_DATA + key) || "null")); } catch (e) { return Promise.resolve(null); } }
    return fetch(cfg.proxy + "/data/" + key, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("http-" + r.status); return r.json(); })
      .then(function (j) { return j && j.value !== undefined ? j.value : null; });
  }
  function save(key, value) {
    if (!st.loggedIn || st.cloud !== "ok") return Promise.reject(new Error("not-signed-in"));
    var body = JSON.stringify({ value: value });
    if (body.length > 1500000) return Promise.reject(new Error("too-big"));
    if (st.mode === "demo") return set(DEMO_DATA + key, JSON.stringify(value)) ? Promise.resolve(true) : Promise.reject(new Error("storage"));
    return fetch(cfg.proxy + "/data/" + key, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || "http-" + r.status); return true; }); });
  }

  /* ---------- The "create a free account" window ---------- */
  var dlg = null;
  function invite(reason) {
    if (st.mode === "off") return;
    if (!dlg) {
      dlg = document.createElement("dialog");
      dlg.className = "gc-invite";
      dlg.setAttribute("aria-labelledby", "gc-invite-title");
      document.body.appendChild(dlg);
      dlg.addEventListener("click", function (e) {
        if (e.target === dlg || e.target.closest("[data-gc-close]")) { dlg.close(); return; }
        var demo = e.target.closest("[data-gc-demo]");
        if (demo) { set(DEMO_KEY, "Friend"); st.loggedIn = true; st.firstName = "Friend"; st.cloud = "ok"; dlg.close(); emit(); }
      });
    }
    var login = st.mode === "live" ? cfg.loginUrl : null;
    var signedInNoCloud = st.loggedIn && st.cloud !== "ok";
    dlg.innerHTML =
      '<button type="button" class="gc-invite-x" data-gc-close aria-label="Close">&times;</button>' +
      '<div class="gc-invite-cloud" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 18a4.5 4.5 0 0 1-.6-9A6 6 0 0 1 18 9.5a4.3 4.3 0 0 1-.5 8.5z"/><path d="M12 11v5M9.5 13.5 12 11l2.5 2.5"/></svg></div>' +
      (signedInNoCloud
        ? '<h2 id="gc-invite-title">Cloud saving is almost ready</h2><p>You\'re signed in, ' + esc(st.firstName || "friend") + '. Our cloud saving is being switched on right now, so for the moment your work is kept safely on this device. Please check back soon!</p>' +
          '<div class="gc-invite-btns"><button type="button" class="btn btn-primary" data-gc-close>OK</button></div>'
        : '<h2 id="gc-invite-title">Keep your sparkle safe</h2>' +
          "<p>" + esc(reason || "Create a free GleamCanvas account to save your work to our cloud.") + "</p>" +
          '<ul class="gc-invite-list"><li>Your designs and journal on every phone and computer</li><li>Nothing lost if you clear your browser</li><li>Your orders in one place, too</li></ul>' +
          '<div class="gc-invite-btns">' +
            (login ? '<a class="btn btn-primary" href="' + esc(login) + '">Create a free account</a><a class="btn btn-outline" href="' + esc(login) + '">I have an account</a>'
                   : '<button type="button" class="btn btn-primary" data-gc-demo>Create a free account</button><button type="button" class="btn btn-outline" data-gc-demo>I have an account</button>') +
          "</div>" +
          '<p class="gc-invite-fine">' + (login ? "No password needed: we'll email you a one-time code. " : "<strong>Preview:</strong> these buttons pretend to sign you in so you can try cloud saving. ") +
            'Everything works without an account; this just keeps a copy safe. <button type="button" class="gc-invite-later" data-gc-close>Not now</button></p>');
    if (typeof dlg.showModal === "function") dlg.showModal(); else if (login) location.href = login;
  }

  /* ---------- Preview site: the header account icon shows the pretend account ---------- */
  if (st.mode === "demo") {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[aria-label="Account"]');
      if (!a) return;
      e.preventDefault();
      if (!st.loggedIn) { invite("Create a free GleamCanvas account to save your designs and journal to our cloud."); return; }
      if (window.confirm("Preview: you're signed in as " + st.firstName + ". Sign out of the pretend account?")) {
        set(DEMO_KEY, null); st.loggedIn = false; st.firstName = ""; st.cloud = ""; emit();
      }
    });
  }

  window.GCCloud = {
    ready: ready,
    status: function () { return st; },
    load: load, save: save, invite: invite,
    onChange: function (fn) { listeners.push(fn); }
  };
})();
